import React, { useEffect, useState } from "react";
import { ApprovedRequestGet } from "../../apis/api/FreightRerquestApi";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie"
import SentRequestView from "../../Models/Freight_RequestModel/Sent_requestViewModel";
import Lodderr from "../Lodder/Lodder";
import CustomTableWrapper from "../../Hooks/CustomTableWrapper";


const Accept_Request = () => {

  const [showModel, setshowModel] = useState();
  const [propsData, setpropsData] = useState();
  const dispatch = useDispatch();
  
  const handleShowModal = (data) => {
    setpropsData(data);
    setshowModel(true);
  };

  const userId = Cookies.get("userID");
  useEffect(() => {
    dispatch(ApprovedRequestGet({id:userId}));
    
   }, []);


  const {approvedRequest,loading}= useSelector((state)=>state.FreightRequest)
  return (
    <>
      {loading && <Lodderr />}
      <SentRequestView show={showModel} handleClose={() => setshowModel(false)} data={propsData} />
      <CustomTableWrapper
        data={approvedRequest}
        itemsPerPage={10}
        enableSearch={true}
        searchKeys={["random_id","full_name", "company_name", "created_at"]}
        columns={[
          { label: "Request ID", field: "random_id", sortable: true },
          { label: "Sender Member Name", field: "full_name	", sortable: true },
          { label: "Sender Company Name", field: "company_name	", sortable: true },
          { label: "Entry Date", field: "created_at", sortable: true },
          { label: "Action", field: "action" },
        ]}
        renderRow={(item, index, currentPage, itemsPerPage) => (
          <tr key={index}>
            <td>{item.random_id}</td>
            <td>{item.full_name	}</td>
            <td>{item.company_name	}</td>
            <td>
              {
                (() => {
                  const date = new Date(item.created_at * 1000);
                  return date.toLocaleDateString('en-US', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  }); 
                })()
              }
            </td>
            <td>
            <div class="d-flex justify-content-center align-items-center gap-2 flex-wrap" >
            <button onClick={() => handleShowModal(item)} className="btn btn-sm btn-warning waves-effect waves-light text-light" to="/request_view" data-bs-toggle="modal" data-bs-target="#form-modal" >  <i class='bx bx-show'></i>
            </button>
            
            </div>
            </td>
          </tr>
        )}
      />


     
    
    </>
  );
};

export default Accept_Request;
